/* eslint-disable complexity */
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/KalenderArbeitsbereich';
import {
  Abschnitt,
  KalenderFilterOptions,
} from '@/domain/mitarbeiter/features/rotationsplan/features/shared/types';

function filterByStandorte<T extends { standortId: string }>(
  items: T[],
  standorte: Standort[],
): T[] {
  if (!standorte.length) return items;
  const ids = new Set(standorte.map((s) => s.id));
  return items.filter((item) => ids.has(item.standortId));
}

function filterArbeitsbereicheByBerufe(
  items: KalenderArbeitsbereich[],
  berufe: string[],
): KalenderArbeitsbereich[] {
  if (!berufe.length) return items;
  const names = new Set(berufe);
  return items.filter((plan) =>
    plan.stationen.some((s) =>
      s.mitarbeiter.some((m) => names.has(m.beruf.name)),
    ),
  );
}

function filterArbeitsbereicheByAbschnitte(
  items: KalenderArbeitsbereich[],
  abschnitte: Abschnitt[],
): KalenderArbeitsbereich[] {
  if (!abschnitte.length) return items;
  const names = new Set(abschnitte.map((a) => a.name));
  return items.filter((plan) =>
    plan.stationen.some((station) =>
      station.mitarbeiter.some((m) => names.has(m.lehrjahr)),
    ),
  );
}

export function filterRotationsplaeneByArbeitsbereiche(
  type: keyof KalenderFilterOptions,
  filterInput: KalenderFilterOptions[keyof KalenderFilterOptions],
  otherFilters: KalenderFilterOptions,
  rotationsplaene: KalenderArbeitsbereich[],
): KalenderArbeitsbereich[] {
  let filtered = [...rotationsplaene];

  if (filterInput.length > 0) {
    switch (type) {
      case 'standorte':
        filtered = filterByStandorte(filtered, filterInput as Standort[]);
        break;
      case 'berufe':
        filtered = filterArbeitsbereicheByBerufe(
          filtered,
          filterInput as string[],
        );
        break;
      case 'abschnitte':
        filtered = filterArbeitsbereicheByAbschnitte(
          filtered,
          filterInput as Abschnitt[],
        );
        break;
    }
  }

  if (type !== 'berufe') {
    filtered = filterArbeitsbereicheByBerufe(filtered, otherFilters.berufe);
  }
  if (type !== 'abschnitte') {
    filtered = filterArbeitsbereicheByAbschnitte(
      filtered,
      otherFilters.abschnitte,
    );
  }
  if (type !== 'standorte') {
    filtered = filterByStandorte(filtered, otherFilters.standorte);
  }

  return filtered;
}
